import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import UnAuthenticatedRoute from './UnauthenticatedRoute';
import AuthenticatedRoute from './AuthenticatedRoute';
import AppLayout from '../Layout/AppLayout';
import {
  authenticatedRoutes,
  publicRoutes,
  unauthenticatedRoutes,
} from './routesConfig';

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
        {/* Unauthenticated Routes */}
        <Route element={<UnAuthenticatedRoute />}>
          {unauthenticatedRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>

        {/* Authenticated Routes */}
        <Route element={<AuthenticatedRoute />}>
          <Route element={<AppLayout />}>
            {authenticatedRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
